// extracted by mini-css-extract-plugin
export default {"containerDelete":"PrimeiroAdquirenteEdit_containerDelete__IR3gP","containerStep":"PrimeiroAdquirenteEdit_containerStep__kMqMJ","button":"PrimeiroAdquirenteEdit_button__5Zo3-"};